import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Loader2, CheckCircle2, ShieldCheck } from 'lucide-react';
import { sellerApi } from '../sellerAuth';

const ResetPassword = () => {
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [pw, setPw] = useState({ next: '', confirm: '' });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.next.length < 6) { setError('Password must be at least 6 characters'); return; }
    if (pw.next !== pw.confirm) { setError('Passwords do not match'); return; }
    setBusy(true); setError('');
    try {
      await sellerApi.post('/seller/reset-password', { token, new_password: pw.next });
      setDone(true);
    } catch (err) {
      setError(err?.response?.data?.detail || 'Could not reset password.');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0b1510] text-white flex flex-col px-7 py-10 max-w-md mx-auto">
      <span className="brand text-2xl mb-8">flix<span className="text-[#3ddc9a]">.</span></span>
      {!token ? (
        <div className="flex-1 flex flex-col items-center justify-center text-center">
          <h1 className="font-display text-2xl font-700">Invalid link</h1>
          <p className="text-white/55 mt-3">This reset link is missing or invalid.</p>
          <button data-testid="reset-goto-login" onClick={() => navigate('/seller')} className="mt-8 text-sm text-[#3ddc9a] font-semibold">Go to log in</button>
        </div>
      ) : done ? (
        <div className="flex-1 flex flex-col items-center justify-center text-center">
          <div className="w-20 h-20 rounded-3xl bg-[#0e9f6e]/15 flex items-center justify-center mb-6"><CheckCircle2 size={40} className="text-[#3ddc9a]" /></div>
          <h1 className="font-display text-3xl font-700">Password updated</h1>
          <p className="text-white/55 mt-3 max-w-xs">You can now log in with your new password.</p>
          <button data-testid="reset-login-btn" onClick={() => navigate('/seller')} className="mt-8 w-full bg-[#0e9f6e] text-white rounded-2xl py-4 text-base font-semibold flex items-center justify-center gap-2 active:scale-[0.98] transition-transform">Log in <ArrowRight size={18} /></button>
        </div>
      ) : (
        <>
          <div className="w-16 h-16 rounded-3xl bg-[#0e9f6e]/15 flex items-center justify-center mb-6"><ShieldCheck size={34} className="text-[#3ddc9a]" /></div>
          <h1 className="font-display text-3xl font-700">Set a new password</h1>
          <p className="text-white/55 mt-2 mb-7 text-sm">Choose a new password for your FLIX account.</p>
          <form onSubmit={submit} className="space-y-3">
            <input data-testid="reset-new-password" type="password" value={pw.next} onChange={(e) => setPw({ ...pw, next: e.target.value })} required minLength={6} placeholder="New password"
              className="w-full rounded-2xl bg-white/5 border border-white/10 px-4 py-3.5 text-sm text-white placeholder-white/35 outline-none focus:border-[#3ddc9a] transition" />
            <input data-testid="reset-confirm-password" type="password" value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} required placeholder="Confirm new password"
              className="w-full rounded-2xl bg-white/5 border border-white/10 px-4 py-3.5 text-sm text-white placeholder-white/35 outline-none focus:border-[#3ddc9a] transition" />
            {error && <p className="text-sm text-[#ff6b5e]">{error}</p>}
            <button data-testid="reset-submit-btn" type="submit" disabled={busy} className="w-full bg-[#0e9f6e] text-white rounded-2xl py-4 text-base font-semibold flex items-center justify-center gap-2 active:scale-[0.98] transition-transform disabled:opacity-60">
              {busy ? <Loader2 size={18} className="animate-spin" /> : <>Update password <ArrowRight size={18} /></>}
            </button>
          </form>
        </>
      )}
    </div>
  );
};

export default ResetPassword;
